import { exhangeShopApi } from '../../api/exchangeShop';
const { getMailOrderList, getMailOrderDetail } = exhangeShopApi;
import { formatTime } from '../../base/CONST';

const STATUS = {
  ALL: 0,
  AUDITING: 1,
  AUDITED: 2,
  SENDED: 3,
  EXCHANGED: 4,
  CLOSED: 5,
  DEAL: 6,
};

export default {
  data() {
    return {
      detailOption: [
        {
          text: 1,
          value: 1,
        },
      ],
      pagination: {
        total: 0,
        page_size: 10,
        page: 1,
      },
      orderState: 0,
      StateOptions: [
        { text: '全部', value: STATUS.ALL },
        { text: '待审核', value: STATUS.AUDITING },
        { text: '审核通过', value: STATUS.AUDITED },
        { text: '已发货', value: STATUS.SENDED },
        { text: '兑换成功', value: STATUS.EXCHANGED },
        { text: '拒绝', value: STATUS.CLOSED },
        { text: '兑换成功', value: STATUS.DEAL },
      ],
      dataList: [],
      tableColums: [
        { id: 'id', label: '订单编号' },
        { id: 'goods_name', label: '商品名称' },
        { id: 'goods_price', label: '价格' },
        { id: 'state', label: '状态' },
        { id: 'create_time', label: '时间', width: '200px' },
        // { id: "sendMsg", label: "配送信息" },
        { id: 'optioner', label: '操作' },
      ],
      STATUS,
      orderDetail: {},
      orderDetailTable: [],
      showDetailDialog: false,
      isShowCurrRejectReason: false,
      currRejectReason: '',
    };
  },
  created() {
    this.getOrderList();
  },
  methods: {
    allDataPageChange(page) {
      this.pagination.page = page;
      this.getOrderList();
    },
    getOrderList() {
      const params = {
        page: this.pagination.page,
        page_size: this.pagination.page_size,
      };
      if (this.orderState) {
        params.state = this.orderState;
      }
      getMailOrderList(params).then(res => {
        if (res.code === 0) {
          this.detailOption = [{ text: 1, value: 1 }];
          this.dataList = (res.data.list || []).map(item => {
            item.create_time = formatTime(item.create_time, true);
            // item.clazz = `state state${item.state}`;
            // item.stateText = `<span class="${item.clazz}">
            //     ${this.getStatusText(item.state)}
            //   </span>`;
            // item.optioner = "<span style='color:#3b9aff'>详情<span>";
            return item;
          });
          this.pagination.total = parseInt(res.data.total_count, 10);
          let len = Math.ceil(
            this.pagination.total / this.pagination.page_size,
          );
          if (len > 1) {
            for (let i = 1; i < len; i++) {
              this.detailOption.push({ text: i + 1, value: i + 1 });
            }
          }
        }
      });
    },
    backToHome() {
      this.$router.push({ name: 'ESHome' });
    },
    allPageSizeChange(pageSize) {
      this.pagination.page_size = pageSize;
      this.pagination.page = 1;
      this.getOrderList();
      // this.getAllList(this.pagination);
    },
    showDetail(rowInfo) {
      console.log('showDetail---', rowInfo);
      const { goods_name, goods_price, id } = rowInfo || {};
      getMailOrderDetail({ id }).then(res => {
        if (res.code === 0) {
          this.orderDetail = res.data;
          this.orderDetailTable = [
            {
              name: goods_name,
              time: formatTime(res.data.create_time, true),
              price: goods_price,
            },
          ];
          this.showDetailDialog = true;
        }
      });
    },
    showCurrRejectReason(data) {
      console.log('showCurrRejectReason---', data);
      if (data.state != 5) return;
      this.currRejectReason = data.close_remarks || '';
      this.isShowCurrRejectReason = true;
    },
    selectStateChange() {
      this.pagination.page = 1;
      this.getOrderList();
    },
    getStatusText(val) {
      let res = '';
      switch (val) {
        case STATUS.AUDITING:
          res = '待审核';
          break;
        case STATUS.AUDITED:
          res = '审核通过';
          break;
        case STATUS.SENDED:
          res = '已发货';
          break;
        case STATUS.EXCHANGED:
          res = '兑换成功';
          break;
        case STATUS.CLOSED:
          res = '已拒绝';
          break;
        case STATUS.DEAL:
          res = '兑换成功';
          break;
      }
      return res;
    },
  },
  filters: {
    getStatusText(val) {
      let res = '';
      switch (val) {
        case STATUS.AUDITING:
          res = '待审核';
          break;
        case STATUS.AUDITED:
          res = '审核通过';
          break;
        case STATUS.SENDED:
          res = '已发货';
          break;
        case STATUS.EXCHANGED:
          res = '兑换成功';
          break;
        case STATUS.CLOSED:
          res = '已拒绝';
          break;
        case STATUS.DEAL:
          res = '兑换成功';
          break;
      }
      return res;
    },
  },
};
